import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["reactRoot"];
  }
  //Load the React code when we initialize
  initialize(){
    console.log("Upload controller initialized");
    this.reactComponentPromise = import("../react/UploadComponent");
  }
  async connect(){
    this.reactComponent = await this.reactComponentPromise;
    const reactRoot = this.reactRootTarget;
    let token = document.querySelector("[name='_csrf']").value;
    const path = reactRoot.getAttribute("path");
    const copy = reactRoot.getAttribute("copy");
    const server_id = reactRoot.getAttribute("server-id") !== "" ? reactRoot.getAttribute("server-id") : "";
    const props = {
      onChange: this.onChange.bind(this),
      csrf_token: token,
      path,
      server_id,
      copy: JSON.parse(copy)
    };
    this.reactComponent.render(reactRoot, props);
  }
  onChange(){
    //Some sort of thing to do with the changes.
    //Hit the API?
    //IDK you decide
  }
  disconnect(){
    const reactRoot = this.reactRootTarget;

    this.reactComponent.destroy(reactRoot);
  }
}
